import { extendTheme } from "@chakra-ui/react";
import { colourOverrides, semanticTokens } from "./Colours";

// Central Chakra theme composition - the single place typography/global-page-defaults/component
// variants live. Imported once by Router.tsx. To change a COLOUR, edit themeColours.ts, not this
// file - this file just wires themeColours' values (via Colours.ts's semanticTokens) into
// Chakra's theme system. See office-portal/DEVNOTES.md §1.12 for the full audit this implements.

export const theme = extendTheme({
  colors: colourOverrides,
  semanticTokens,

  // Default text font/size - previously entirely unset (Chakra's own built-in system-font
  // fallback stack, invisibly). Written out explicitly here so it's a named, editable line
  // instead of an invisible default - value is Chakra's own stock stack, so this changes nothing
  // about how the app currently renders.
  fonts: {
    heading: `-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"`,
    body: `-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"`,
  },

  // Global page-level defaults (Chakra's official mechanism for body background/text colour/size
  // - https://chakra-ui.com/docs/styled-system/global-styles). "app-bg" replaces the same literal
  // value previously hardcoded on Sidebar.tsx's content-wrapper Box.
  styles: {
    global: {
      body: {
        bg: "app-bg",
        color: "default-text",
        fontSize: "md",    // Chakra's own default baseline (16px) - "Default-text-size" target
      },
    },
  },

  components: {
    Button: {
      variants: {
        // Opt-in variant for ActionBar buttons (BaseTemplate.Header content) - NOT the default
        // for every Button app-wide, since pages intentionally use other colorSchemes for
        // context-specific actions (delete, cancel, etc.) that this must not override. Adopt
        // with variant="actionBar" on a per-button basis.
        actionBar: {
          // One fixed size for every actionBar button (Chakra's "sm": 32px tall, 14px text), so
          // the upload page's [Upload], the PreFilter's [Run] and the rest all read as the same
          // control. Per-button size="..." props are deliberately not used with this variant -
          // a 40px [Upload] next to a 20px [Run] was the inconsistency this fixes.
          h: 8,
          minW: 8,
          fontSize: "sm",
          px: 3,
          bg: "action-bar-button-enabled",
          color: "white",
          _hover: { bg: "action-bar-button-enabled", opacity: 0.85 },
          _active: { bg: "action-bar-button-enabled", opacity: 0.7 },
          // Disabled state intentionally left to Chakra's own default _disabled (opacity-based
          // dimming, not a solid-colour swap) rather than forcing "action-bar-button-disabled" in
          // here - see that token's own comment in Colours.ts for why.
        },
      },
    },
  },
});
